<template>
    <h3 class="init-message animate-moveFromTop">
        <span><slot/></span>
    </h3>
</template>

<script setup lang="ts">
</script>
<style>

.init-message {
    height: 100%;
    padding: 20px;
    position: absolute;
    top: 0;
    margin: 0 !important;
    vertical-align: middle;
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
    left: 0;
    right: 0;
    text-align: center;
}
</style>
